import PropTypes from 'prop-types';

import defaultUserAvatar from 'assets/user_avatar.svg';

import styles from './styles.module.scss';

const ProfileSection = ({ authUser }) => (
  <div className={styles['profile-section']}>
    <div className={styles['section-heading']}>
      <span className={styles['heading-text']}>
        Profile
      </span>
    </div>

    {/* Avatar + full name */}
    <div className={styles['profile-avatar-row']}>
      <img
        src={authUser?.profile_photo || defaultUserAvatar}
        alt="Avatar"
        className={styles['profile-avatar']}
      />
      <div className={styles['profile-field']}>
        <span className={styles['field-label']}>
          Full name
        </span>
        <input
          className={styles['field-input']}
          value={authUser?.full_name || ''}
          readOnly
        />
      </div>
    </div>

    {/* Email */}
    <div className={styles['profile-inline-row']}>
      <div className={styles['inline-left']}>
        <span className={styles['field-label']}>
          Email
        </span>
        <span className={styles['field-value']}>
          {authUser?.email || '—'}
        </span>
      </div>
      {/* {!isGoogleUser && (
        <button type="button" className={styles['outline-btn']}>
          Change password
        </button>
      )} */}
    </div>

    {/* Delete account */}
    {/* <div className={styles['profile-inline-row']}>
      <div className={styles['inline-left']}>
        <span className={styles['field-label']}>
          Delete account
        </span>
        <span className={styles['field-value']}>
          Permanently delete your account and all associated data
        </span>
      </div>
      <button type="button" className={styles['danger-btn']}>
        Delete account
      </button>
    </div> */}
  </div>
);

ProfileSection.propTypes = {
  authUser: PropTypes.shape({
    profile_photo: PropTypes.string,
    full_name: PropTypes.string,
    email: PropTypes.string,
  }),
};

export default ProfileSection;
